import Table from 'apollo-react/components/Table';
import moment from 'moment';
import React from 'react';

import { tablePaginationProps } from '../../components/FormattedTable';
import { useTranslation } from '../../custom-hooks/useTranslation';
import {
  getFilterComponentByDataType,
  getFilterFunctionByDataType,
  getSortFunction,
} from '../../form-designer/utils/controls/ssGrid.utils';
import { safeFormatDateString } from '../../utils/dateUtils';
import { createCustomCompareDatesForTable } from '../../utils/formHistoryUtils';

const RenderDate = ({ row, column: { accessor } }) => {
  const rowValue = row[accessor];
  const date = rowValue && moment(rowValue).isValid() ? safeFormatDateString(rowValue) : rowValue;

  return <>{date}</>;
};

const parseColumns = (columns) =>
  (columns || []).map((column) => ({
    header: column.accessor,
    accessor: column.accessor,
    sortFunction:
      column.dataType === 'System.DateTime'
        ? createCustomCompareDatesForTable
        : getSortFunction(column.dataType),
    filterFunction: getFilterFunctionByDataType({
      dataType: column.dataType,
      accessor: column.accessor,
    }),
    filterComponent: getFilterComponentByDataType({ dataType: column.dataType }),
    customCell: column.dataType === 'System.DateTime' ? RenderDate : undefined,
  }));

const parseRows = (rows) =>
  (rows || []).map((row) => ({
    ...row,
    MinRequiredVersion: row.MinimumRequiredVersion,
    CreatedDate: (row.CreatedDate && moment.utc(row.CreatedDate).local()) || '',
  }));

export const ExternalDataSourceTable = ({ isLoading, sourceDataList }) => {
  const translateString = useTranslation();
  const columns = parseColumns(sourceDataList?.columns);
  const rows = parseRows(sourceDataList?.rows);

  return (
    <Table
      isLoading={isLoading}
      columns={columns}
      rows={rows}
      showFilterIcon
      initialSortOrder="asc"
      rowsPerPageOptions={[10, 20, 50, 100, translateString('All')]}
      defaultRowsPerPage={10}
      rowProps={{ hover: true }}
      tablePaginationProps={tablePaginationProps(translateString)}
      filterTooltipText={translateString('Filter')}
      sortTooltipText={translateString('Sort')}
      filterButtonLabel={translateString('Filter')}
    />
  );
};

export default ExternalDataSourceTable;
